import React from "react";
import "../styles/Products.css";

import {
  FaCheckCircle,
  FaArrowRight,
} from "react-icons/fa";

import accounts from "../assets/images/accounts-dashboard-1.png";
import nozzle from "../assets/images/nozel-dashboard.png";
import printer from "../assets/images/printer.png";
import display from "../assets/images/external-display.png";

const products = [
  {
    title: "Fuel Station Accounts ERP",
    image: accounts,
    reverse: false,
    features: [
      "Balance Sheet",
      "Profit & Loss",
      "Cash Flow",
      "Inventory Management",
      "Debtors & Creditors",
    ],
    description:
      "Complete accounting software designed specifically for petrol pumps with advanced reporting and financial management.",
  },

  {
    title: "Live Nozzle Automation",
    image: nozzle,
    reverse: true,
    features: [
      "Live Nozzle Sale",
      "Tank Stock",
      "Operator Monitoring",
      "Shift Closing",
      "Live Dashboard",
    ],
    description:
      "Monitor fuel dispensing in real time and keep complete control over every fueling transaction.",
  },

  {
    title: "Fuel Receipt Printing",
    image: printer,
    reverse: false,
    features: [
      "Automatic Slip Printing",
      "Customer Receipts",
      "Printer Integration",
      "Fast Printing",
      "Error Free",
    ],
    description:
      "Generate computerized receipts automatically after every fueling transaction.",
  },

  {
    title: "External Display System",
    image: display,
    reverse: true,
    features: [
      "Large LED Display",
      "Live Amount",
      "Live Liters",
      "Customer Visibility",
      "Easy Installation",
    ],
    description:
      "External customer display connected directly with fuel dispensers showing fueling information live.",
  },
];

const Products = () => {
  return (
    <section className="products" id="products">

      <div className="product-heading">

        <span>OUR PRODUCTS</span>

        <h2>Solutions Built for Fuel Stations</h2>

        <p>
          Reliable software and hardware solutions designed to simplify
          fuel station management and improve operational efficiency.
        </p>

      </div>

      {products.map((item, index) => (

        <div
          key={index}
          className={`product-row ${
            item.reverse ? "reverse" : ""
          }`}
        >

          <div className="product-image">

            <img src={item.image} alt={item.title} />

          </div>

          <div className="product-content">

            <h3>{item.title}</h3>

            <p>{item.description}</p>

            <div className="feature-list">

              {item.features.map((feature, i) => (

                <div key={i}>

                  <FaCheckCircle />

                  {feature}

                </div>

              ))}

            </div>

            <button>

              Request Demo

              <FaArrowRight />

            </button>

          </div>

        </div>

      ))}

    </section>
  );
};

export default Products;